
import axios from "axios";
import React, { useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import { MdMenu } from "react-icons/md";
import UserAccount from "./UserAccount";
import { MyContext } from "../../../context/MyContext";

function KycDetail() {
  const navigate = useNavigate();
  const { getKycData, KycData, kycPending } = useContext(MyContext);
  const [father_husbandName, setfather_husbandName] = useState("");
  const [motherName, setMotherName] = useState("");
  const [adharNumber, setAdharNumber] = useState("");
  const [panNumber, setPanNumber] = useState("");
  const [adharFront, setAdharFront] = useState(null);
  const [adharBack, setAdharBack] = useState(null);
  const [panImage, setPanImage] = useState(null);
  const [errors, setErrors] = useState({});
  const [userAccount, setUserAccount] = useState(false);
  const userId = localStorage.getItem("userId");

  const handleFile = (setter) => (e) => {
    const file = e.target.files[0];
    if (file) setter(file);
  };

  const validate = () => {
    const newErrors = {};
    if (!father_husbandName.trim())
      newErrors.father_husbandName = "Father/Husband Name is required";
    if (!motherName.trim()) newErrors.motherName = "Mother Name is required";
    if (!adharNumber.match(/^\d{12}$/))
      newErrors.adharNumber = "Aadhaar must be 12 digits";
    if (!panNumber.match(/^[A-Z]{5}[0-9]{4}[A-Z]{1}$/))
      newErrors.panNumber = "Invalid PAN number format";
    if (!adharFront) newErrors.adharFront = "Aadhaar front image is required";
    if (!adharBack) newErrors.adharBack = "Aadhaar back image is required";
    if (!panImage) newErrors.panImage = "PAN image is required";
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validate()) return;

    const formData = new FormData();
    formData.append("addharFront", adharFront);
    formData.append("addharBack", adharBack);
    formData.append("pan", panImage);
    formData.append("mother_name", motherName);
    formData.append("father_or_husband_name", father_husbandName);
    formData.append("aadhaar_number", adharNumber);
    formData.append("pan_number", panNumber);

    try {
      await axios.post(
        `${process.env.REACT_APP_NODE}user/kycDetails/${userId}`,
        formData
      );
      window.alert("Form Submitted Successfully");
      getKycData();
      navigate("/account/account_details");
    } catch (error) {
      console.error(error);
      window.alert("Something went wrong");
    }
  };
  const { verifyMlmUser } = useContext(MyContext);

  return (
    <div className={`flex pt-4 md:pt-2 ${verifyMlmUser ? "lg:pt-[80px]" : "lg:pt-40"}`}>
      <div className={`md:block ${userAccount ? "block" : "hidden"} absolute md:relative bg-white shadow-md p-4 z-10`}>
        <UserAccount showUserAccount={setUserAccount} />
      </div>

      <div className="absolute right-4 mt-2 md:hidden z-20">
        <MdMenu
          onClick={() => setUserAccount((prev) => !prev)}
          className="text-4xl cursor-pointer border rounded-lg px-1"
        />
      </div>

      <div className="w-full px-4 py-6">
        {kycPending ? (
          <div className="max-w-4xl mx-auto bg-white shadow-lg rounded-2xl p-6">
            <h2 className="text-2xl font-bold mb-6 text-center text-purple-700">KYC Form</h2>
            <form onSubmit={handleSubmit} className="space-y-6">
              {/* Row 1 */}
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div>
                  <label className="block mb-1 font-medium">Father's/Husband Name</label>
                  <input
                    type="text"
                    className="w-full p-3 border rounded-xl focus:ring-2 focus:ring-purple-500"
                    onChange={(e) => setfather_husbandName(e.target.value)}
                  />
                  {errors.father_husbandName && (
                    <p className="text-red-500 text-sm">{errors.father_husbandName}</p>
                  )}
                </div>
                <div>
                  <label className="block mb-1 font-medium">Mother Name</label>
                  <input
                    type="text"
                    className="w-full p-3 border rounded-xl focus:ring-2 focus:ring-purple-500"
                    onChange={(e) => setMotherName(e.target.value)}
                  />
                  {errors.motherName && (
                    <p className="text-red-500 text-sm">{errors.motherName}</p>
                  )}
                </div>
              </div>

              {/* Row 2 */}
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div>
                  <label className="block mb-1 font-medium">Aadhaar Number</label>
                  <input
                    type="text"
                    className="w-full p-3 border rounded-xl focus:ring-2 focus:ring-purple-500"
                    onChange={(e) => setAdharNumber(e.target.value)}
                  />
                  {errors.adharNumber && (
                    <p className="text-red-500 text-sm">{errors.adharNumber}</p>
                  )}
                </div>
                <div>
                  <label className="block mb-1 font-medium">Aadhaar Front Image</label>
                  <input
                    type="file"
                    accept="image/*"
                    className="w-full p-3 border rounded-xl focus:ring-2 focus:ring-purple-500"
                    onChange={handleFile(setAdharFront)}
                  />
                  {errors.adharFront && (
                    <p className="text-red-500 text-sm">{errors.adharFront}</p>
                  )}
                </div>
              </div>

              {/* Row 3 */}
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div>
                  <label className="block mb-1 font-medium">Aadhaar Back Image</label>
                  <input
                    type="file"
                    accept="image/*"
                    className="w-full p-3 border rounded-xl focus:ring-2 focus:ring-purple-500"
                    onChange={handleFile(setAdharBack)}
                  />
                  {errors.adharBack && (
                    <p className="text-red-500 text-sm">{errors.adharBack}</p>
                  )}
                </div>
                <div>
                  <label className="block mb-1 font-medium">PAN Number</label>
                  <input
                    type="text"
                    className="w-full p-3 border rounded-xl focus:ring-2 focus:ring-purple-500"
                    value={panNumber}
                    onChange={(e) => setPanNumber(e.target.value)}
                  />
                  {errors.panNumber && (
                    <p className="text-red-500 text-sm">{errors.panNumber}</p>
                  )}
                </div>
              </div>

              {/* Row 4 */}
              <div>
                <label className="block mb-1 font-medium">PAN Image</label>
                <input
                  type="file"
                  accept="image/*"
                  className="w-full p-3 border rounded-xl focus:ring-2 focus:ring-purple-500"
                  onChange={handleFile(setPanImage)}
                />
                {errors.panImage && (
                  <p className="text-red-500 text-sm">{errors.panImage}</p>
                )}
              </div>

              <div className="text-center">
                <button
                  type="submit"
                  className="bg-purple-600 hover:bg-purple-700 text-white px-8 py-3 rounded-xl transition duration-300"
                >
                  Submit
                </button>
              </div>
            </form>
          </div>
        ) : (
          <div className="overflow-x-auto mt-8">
            <h2 className="text-2xl font-bold text-center text-purple-700 mb-4">KYC Detail</h2>
            <table className="w-full border border-purple-300 rounded-xl overflow-hidden shadow-md text-sm">
              <thead className="bg-purple-100 text-purple-700">
                <tr>
                  {["Father/Husband Name", "Mother Name", "Aadhaar Number", "PAN Number", "Aadhaar Front", "Aadhaar Back", "PAN"].map((heading) => (
                    <th key={heading} className="px-2 py-2 border border-purple-300">{heading}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                <tr className="text-center">
                  <td className="border px-2 py-2">{KycData?.father_or_husband_name}</td>
                  <td className="border px-2 py-2">{KycData?.mother_name}</td>
                  <td className="border px-2 py-2">{KycData?.aadhaar_number}</td>
                  <td className="border px-2 py-2">{KycData?.pan_number}</td>
                  <td className="border px-2 py-2">
                    <img
                      src={`${process.env.REACT_APP_NODE_CATEGORY}uploads/userProfile/${KycData?.addharFront}`}
                      alt="Aadhaar Front"
                      className="h-16 object-contain mx-auto"
                    />
                  </td>
                  <td className="border px-2 py-2">
                    <img
                      src={`${process.env.REACT_APP_NODE_CATEGORY}uploads/userProfile/${KycData?.addharBack}`}
                      alt="Aadhaar Back"
                      className="h-16 object-contain mx-auto"
                    />
                  </td>
                  <td className="border px-2 py-2">
                    <img
                      src={`${process.env.REACT_APP_NODE_CATEGORY}uploads/userProfile/${KycData?.pan_card_image}`}
                      alt="PAN"
                      className="h-16 object-contain mx-auto"
                    />
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
}

export default KycDetail;
